import React, { useEffect } from "react";
import { KTable } from "@kyburz/kdesign-system";
import { useDispatch } from "react-redux";
import { setAlert } from "../../redux/actions/actions";
import { createStatusStream } from "../../apiCalls/admin/cardreader";
import { CRCardsReply } from "../../apiCalls/admin/cardreader_pb";
import useSafeSetState from "../../hooks/useSafeSetState";

const Companycards: React.FC = () => {
  const [
    { rows, reconnect_attempt },
    setState,
  ] = useSafeSetState({
    rows: [],
    reconnect_attempt: 0,
  });
  const dispatch = useDispatch();

  const columns = React.useMemo(
    () => [
      {
        Header: "Customer",
        accessor: "customer",
        defaultCanSort: true,
      },
      {
        Header: "Description",
        accessor: "description",
        width: 250,
        defaultCanSort: true,
      },
      {
        Header: "Last usage",
        accessor: "last_usage",
        defaultCanSort: true,
      },
      {
        Header: "current imei",
        accessor: "current_imei",
        defaultCanSort: true,
      },
  ], []);
  const handleDisconnect = () => {
    const secs = 2**reconnect_attempt <= 128 ? 2**reconnect_attempt : 128;

    dispatch(
      setAlert(`connection error, retry in ${secs} sec`, "error"),
    );
    setTimeout(() => {
      setState({ reconnect_attempt: reconnect_attempt + 1 })
    }, secs * 1000);
  };
  const handleStatus = (message : CRCardsReply) => {
    const cards = [];
    const card_infos = message.getCardInfoList();
    // eslint-disable-next-line no-restricted-syntax
    for(const card_info of card_infos) {
      // @ts-ignore
      cards.push({customer: card_info.getCustomer(), description: card_info.getCardDescription(), last_usage: card_info.getLastUsage(), current_imei: card_info.getCurrentImei()});
    }
    setState({ rows: cards, reconnect_attempt: 0 });
  };
  useEffect(() => {
    const s = createStatusStream("", handleStatus, handleDisconnect);
    return function cleanup() {
      s.close();
    }
  }, []);
  useEffect(() => {
    if (reconnect_attempt > 0) {
      const s = createStatusStream("", handleStatus, handleDisconnect);
      return function cleanup() {
        s.close();
      };
    }
    return function cleanup() {};
  }, [reconnect_attempt]);
  return (
    <>
      <KTable columns={columns} data={rows} />
    </>
  );
};

export default Companycards;